/**
 * 定数定義.
 */

// 画面遷移用
export const GMN_PATH = {
  // メニュー
  MENU: '/menu',
  CUSTOMER_INFO_LIST: '/CustomerInformation/CustomerInformationList',
  CUSTOMER_INFO_INFO: '/CustomerInformation/CustomerInformationInfo',
  CUSTOMER_SECURITY_INFO_LIST: '/CustomerSecurityInfoManage/CustomerSecurityInfoList',
  CUSTOMER_SECURITY_INFO: '/CustomerSecurityInfoManage/CustomerSecurityInfo',
  SURVEY_YEAR_COMPANY_LIST: '/SurveyYearCompany/SurveyYearCompanyList',
  SURVEY_YEAR_COMPANY_INFO: '/SurveyYearCompany/SurveyYearCompanyInfo',
  SURVEY_INDUSTRY_LIST: '/SurveyIndustry/SurveyIndustryList',
  SURVEY_INDUSTRY_INFO: '/SurveyIndustry/SurveyIndustryInfo',
  SURVEY_REASON_LIST: '/SurveyReason/SurveyReasonList',
  SURVEY_REASON_INFO: '/SurveyReason/SurveyReasonInfo',
  ZENSITETU_LIST: '/Zensitetu/ZensitetuList',
  ZENSITETU_INFO: '/Zensitetu/ZensitetuInfo',
  ZENSITETU_ITAKU_LIST: '/ZensitetuItaku/ZensitetuItakuList',
  SURVEY_POPULATION_LIST: '/SurveyPopulation/SurveyPopulationList',
  TSTK_KASYO_MANAGE_LIST: '/TstkKasyoManage/TstkKasyoManageList',
  TSTK_KASYO_MANAGE_INFO: '/TstkKasyoManage/TstkKasyoManageInfo',
  ANNUAL_SURVERY_PLAN_LIST: '/AnnualSurveyPlan/AnnualSurveyPlanList',
  ANNUAL_SURVERY_PLAN_INFO: '/AnnualSurveyPlan/AnnualSurveyPlanInfo',
  PARCEL_SELECTION: '/SurveyYearCompany/Parcelselection',
  LOGSEARCH_LIST: '/LogSearch/LogSearchList',
  USER_MASTER_LIST: '/UserMaster/UserMasterList',
  USER_MASTER_INFO: '/UserMaster/UserMasterInfo',
  INVESTIGATION_KUKAKU_LIST: '/InvestigationKukaku/InvestigationKukakuList',
  APPLICATION_APPROVAL_LIST: '/ApplicationApproval/ApplicationApprovalList',
  FILE_MNG_LIST: '/FileMng/FileMngList',
  SYSTEM_SETTING: '/Scz/SystemSetting',
  GOAL_INVEST_SETTING_LIST: '/GoalInvestSetting/GoalInvestSettingList',
  GOAL_INVEST_SETTING_MESH: '/GoalInvestSetting/GoalInvestSettingMesh',
  TSTK_RESULT_REPORT_LIST: '/TstkResultReport/TstkResultReportList',
  TSTK_KASYO_LIST: '/TstkKasyo/TstkKasyoList',
  TSTK_RESULT_CONFIRM_LIST: '/TstkResultConfirm/TstkResultConfirmList',
  ITAKU_SETTING_LIST: '/ItakuSetting/ItakuSettingList',
  ITAKU_TSTK_GUTISU_LIST: '/ItakuSetting/ItakuTsTkGutiSuList',
  TSTK_ACTUAL_CONFIRM_LIST: '/TsTkActualConfirm/TsTkActualConfirmList',
  TSTK_KOTEI_LIST: '/TstkMoDasiHistory/TstkKoTeiList',
  TSTK_PROGRESS_MONTH_KOTEI_LIST: '/TstkProgressMonthKotei/TstkProgressMonthKoteiList',
  TSTK_PROGRESS_BLOCK_LIST: '/TstkProgressBlock/TstkProgressBlockList',
  TSTK_PROGRESS_BLOCK_REPORT_LIST: '/TstkProgressBlock/TstkProgressBlockReportList',
  TSTK_IMPLEMENT_STATUS_LIST: '/TsTkImplementStatus/TsTkImplementStatusList',
  ITAKU_TSTK_GUTISU_SK_LIST: '/ItakuSetting/ItakuTsTkGutiSuSkList',
  CUSTOMER_INDIVIDUAL_MANAGE_LIST: '/CustomerIndividualManage/CustomerIndividualManageList',
  CUSTOMER_INDIVIDUAL_MANAGE_INFO: '/CustomerIndividualManage/CustomerIndividualManageInfo',
  TK_INVESTIGATION_TOTAL_LIST: '/TkInvestigationTotal/TkInvestigationTotalList',
};

export const GMN = {
  MENU: {id: 'MENU', title: 'メニュー', name: 'メニュー'},
  CUSTOMER_INFO_LIST: {id: 'CUSTOMER_INFO_LIST', title: 'お客さま情報照会', name: 'お客さま情報照会', gmnId: 'SCZ1008'},
  CUSTOMER_INFO_INFO: {id: 'CUSTOMER_INFO_INFO', title: 'お客さま情報詳細', name: 'お客さま情報詳細', gmnId: 'SCZ1009'},
  CUSTOMER_SECURITY_INFO_LIST: {id: 'CUSTOMER_SECURITY_INFO_LIST', title: 'お客さま保安情報検索', name: 'お客さま保安情報検索', gmnId: ''},
  CUSTOMER_SECURITY_INFO: {id: 'CUSTOMER_SECURITY_INFO', title: 'お客さま保安情報', name: 'お客さま保安情報', gmnId: ''},
  SURVEY_YEAR_COMPANY_LIST: {id: 'SURVEY_YEAR_COMPANY_LIST', title: '調査年度・委託エリア管理', name: '調査年度・委託エリア管理', gmnId: 'SCI1001'},
  SURVEY_YEAR_COMPANY_INFO: {id: 'SURVEY_YEAR_COMPANY_INFO', title: '調査年度・委託エリア登録', name: '調査年度・委託エリア登録', gmnId: 'SCI1002'},
  SURVEY_INDUSTRY_LIST: {id: 'SURVEY_INDUSTRY_LIST', title: '調査業種管理', name: '調査業種管理', gmnId: 'SCA1001'},
  SURVEY_INDUSTRY_INFO: {id: 'SURVEY_INDUSTRY_INFO', title: '調査業種登録', name: '調査業種登録', gmnId: 'SCA1002'},
  SURVEY_REASON_LIST: {id: 'SURVEY_REASON_LIST', title: '翌年度再調査管理', name: '翌年度再調査管理', gmnId: 'SCB1001'},
  SURVEY_REASON_INFO: {id: 'SURVEY_REASON_INFO', title: '翌年度再調査理由登録', name: '翌年度再調査理由登録', gmnId: 'SCB1002'},
  ZENSITETU_LIST: {id: 'ZENSITETU_LIST', title: '毎年調査お客さま全使撤リスト一覧', name: '毎年調査お客さま全使撤リスト一覧', gmnId: 'SCA1011'},
  ZENSITETU_INFO: {id: 'ZENSITETU_INFO', title: '毎年調査お客さま全使撤リスト', name: '毎年調査お客さま全使撤リスト', gmnId: 'SCA1012'},
  ZENSITETU_ITAKU_LIST: {id: 'ZENSITETU_ITAKU_LIST', title: '毎年調査お客さま全使撤リスト(調査機関用)', name: '毎年調査お客さま全使撤リスト(調査機関用)', gmnId: 'SCA1014'},
  SURVEY_POPULATION_LIST: {id: 'SURVEY_POPULATION_LIST', title: '調査口数一覧', name: '調査口数一覧', gmnId: 'SCD1001'},
  TSTK_KASYO_MANAGE_LIST: {id: 'TSTK_KASYO_MANAGE_LIST', title: '調査・点検箇所追加交付管理', name: '調査・点検箇所追加交付管理', gmnId: 'SCD1002'},
  TSTK_KASYO_MANAGE_INFO: {id: 'TSTK_KASYO_MANAGE_INFO', title: '調査・点検箇所追加交付登録', name: '調査・点検箇所追加交付登録', gmnId: 'SCD1003'},
  ANNUAL_SURVERY_PLAN_LIST: {id: 'ANNUAL_SURVERY_PLAN_LIST', title: '年度計画登録', name: '年度計画登録', gmnId: 'SCE1001'},
  ANNUAL_SURVERY_PLAN_INFO: {id: 'ANNUAL_SURVERY_PLAN_INFO', title: '年度計画登録(担当者)', name: '年度計画登録(担当者)', gmnId: 'SCE1002'},
  PARCEL_SELECTION: {id: 'PARCEL_SELECTION', title: '区画選択', name: '区画選択', gmnId: 'SCI1003'},
  LOGSEARCH_LIST: {id: 'LOGSEARCH_LIST', title: 'ログ検索', name: 'ログ検索', gmnId: 'SCZ1007'},
  USER_MASTER_LIST: {id: 'USER_MASTER_LIST', title: 'ユーザ一覧', name: 'ユーザ一覧', gmnId: 'SCZ1003'},
  USER_MASTER_INFO: {id: 'USER_MASTER_INFO', title: 'ユーザ詳細', name: 'ユーザ詳細', gmnId: 'SCZ1004'},
  INVESTIGATION_KUKAKU_LIST: {id: 'INVESTIGATION_KUKAKU_LIST', title: '定期調査シート集計表出力', name: '定期調査シート集計表出力', gmnId: ''},
  APPLICATION_APPROVAL_LIST: {id: 'APPLICATION_APPROVAL_LIST', title: '承認一覧', name: '承認一覧', gmnId: 'SCZ1005'},
  FILE_MNG_LIST: {id: 'FILE_MNG_LIST', title: 'ファイル管理', name: 'ファイル管理', gmnId: 'SCZ1011'},
  SYSTEM_SETTING: {id: 'SYSTEM_SETTING', title: 'システム設定', name: 'システム設定', gmnId: 'SCZ1010'},
  GOAL_INVEST_SETTING_LIST: {id: 'GOAL_INVEST_SETTING_LIST', title: '目標調査件数設定', name: '目標調査件数設定', gmnId: 'SCC1001'},
  GOAL_INVEST_SETTING_MESH: {id: 'GOAL_INVEST_SETTING_MESH', title: '委託エリア設定', name: '委託エリア設定', gmnId: 'SCC1002'},
  TSTK_RESULT_REPORT_LIST: {id: 'TSTK_RESULT_REPORT_LIST', title: '調査・点検結果報告(調査機関用)', name: '調査・点検結果報告(調査機関用)', gmnId: ''},
  TSTK_KASYO_LIST: {id: 'TSTK_KASYO_LIST', title: '調査・点検箇所一覧', name: '調査・点検箇所一覧', gmnId: ''},
  TSTK_RESULT_CONFIRM_LIST: {id: 'TSTK_RESULT_CONFIRM_LIST', title: '調査・点検結果確認', name: '調査・点検結果確認', gmnId: 'SCG1001'},
  ITAKU_SETTING_LIST: {id: 'ITAKU_SETTING_LIST', title: '調査・点検機関設定', name: '調査・点検機関設定', gmnId: ''},
  ITAKU_TSTK_GUTISU_LIST: {id: 'ITAKU_TSTK_GUTISU_LIST', title: '調査・点検口数(予定)一覧', name: '調査・点検口数(予定)一覧', gmnId: ''},
  TSTK_ACTUAL_CONFIRM_LIST: {id: 'TSTK_ACTUAL_CONFIRM_LIST', title: '調査・点検実績確認', name: '調査・点検実績確認', gmnId: 'SCH1001'},
  TSTK_KOTEI_LIST: {id: 'TSTK_KOTEI_LIST', title: '調査・点検行程照会', name: '調査・点検行程照会', gmnId: ''},
  TSTK_PROGRESS_MONTH_KOTEI_LIST: {id: 'TSTK_PROGRESS_MONTH_KOTEI_LIST', title: '調査・点検進捗状況照会(月別・工程別)', name: '調査・点検進捗状況照会(月別・工程別)', gmnId: 'SCF1008'},
  TSTK_PROGRESS_BLOCK_LIST: {id: '', title: '調査・点検進捗状況照会(ブロック別)', name: '調査・点検進捗状況照会(ブロック別)', gmnId: 'SCF1009'},
  TSTK_PROGRESS_BLOCK_REPORT_LIST: {id: '', title: '調査・点検結果報告(NWC用)', name: '調査・点検結果報告(NWC用)', gmnId: ''},
  TSTK_IMPLEMENT_STATUS_LIST: {id: 'TSTK_IMPLEMENT_STATUS_LIST', title: '定期調査実施状況', name: '定期調査実施状況', gmnId: 'SCY1001'},
  ITAKU_TSTK_GUTISU_SK_LIST: {id: 'ITAKU_TSTK_GUTISU_SK_LIST', title: '調査・点検対象集計', name: '調査・点検対象集計', gmnId: 'SCH1002'},
  CUSTOMER_INDIVIDUAL_MANAGE_LIST: {id: 'CUSTOMER_INDIVIDUAL_MANAGE_LIST', title: 'お客さま個別管理', name: 'お客さま個別管理', gmnId: 'SCY1002'},
  CUSTOMER_INDIVIDUAL_MANAGE_INFO: {id: 'CUSTOMER_INDIVIDUAL_MANAGE_INFO', title: 'お客さま個別登録', name: 'お客さま個別登録', gmnId: 'SCY1003'},
  TK_INVESTIGATION_TOTAL_LIST: {id: 'TK_INVESTIGATION_TOTAL_LIST', title: '屋内線定期調査集計', name: '屋内線定期調査集計', gmnId: 'SCY1004'},
};

// Grid状態
export const GRID_STATUS = {
  INSERT: 'insert',
  UPDATE: 'update',
  DELETE: 'delete',
};

// アップロード可能なファイル
export const UPLOAD_EXTENSION = '';

// 取込可能なファイル
export const IMPORTABLE_EXTENSION = '.xlsx';

// 検索最大件数
export const SEARCHRESULT_MAX = 2000;

// 汎用マスタのカテゴリ
export const CATEGORY_TYPE = {
  CLASSIFICATION_CODE: 'classification_code',
  SURVEY_MANAGEMENT_CATEGORY_CODE: 'survey_management_category_code',
  SURVEY_INDUSTRY_CODE: 'survey_industry_code',
  SURVEY_REASON_CODE: 'survey_reason_code',
  KK_KIK_KNR_KBN: 'kk_kik_knr_kbn',
  DISTRIBUTED_POWER_INFO: 'distributed_power_info',
  LEAD_IN_WIRE_TI_IDS_CD: 'lead_in_wire_ti_ids_cd',
  SURVEY_CHECK_DATA_CATEGORY: 'survey_check_data_category',
  KIR_HOU_CD: 'kir_hou_cd',
  LEAD_IN_WIRE_CHANGE_CATEGORY: 'lead_in_wire_change_category',
  NW_OFFICE_CODE: 'nw_office_code',
  KY_CPS_SVM_CD: 'ky_cps_svm_cd',
  KY_KY_JOK_KBN: 'ky_ky_jok_kbn',
  TI_IDS_CD: 'ti_ids_cd',
  KY_GSH_CD: 'ky_gsh_cd',
  LIGHT_POWER_INDUSTRY_CATEGORY: 'light_power_industry_category',
  SURVEY_CHECK_CONSIGN_AREA_CODE: 'survey_check_consign_area_code',
  SURVEY_YEAR_CONSIGN_AREA_STATUS: 'survey_year_consign_area_status',
  INPUTFORM_TYPE_CODE: 'inputform_type_code',
  CORP_CD: 'corp_cd',
  SURVEY_AGENCY_OFFICE_CODE: 'survey_agency_office_code',
  APPLICATION_FROM_ID: 'application_from_id',
  STEP_APPROVAL: 'step_approval',
  DOC_TYPE: 'doc_type',
  HAISI_FLG: 'haisi_flg',
  CI_ZKS_KBN: 'ci_zks_kbn',
  SURVEY_CHECK_ISSUE_SEASON_CATEGORY: 'survey_check_issue_season_category',
  SURVEY_CHECK_CYCLE_CODE: 'survey_check_cycle_code',
  HKSNTK_PROC_CD: 'hksntk_proc_cd',
  HKSNTK_PROC_SMDS_FLG: 'hksntk_proc_smds_flg',
  CHECK_TARGET_CODE: 'check_target_code',
  LEAD_IN_WIRE_SHARED: 'lead_in_wire_shared',
  LEAD_IN_WIRE_CHECK_BAD_CONTENT: 'lead_in_wire_check_bad_content',
  IS_DIFF_OF_POLE_NO: 'is_diff_of_pole_no',
  OPERATION_PERMISSION_TYPE: 'operation_permission_type',
  CHECK_UNIT_CODE: 'check_unit_code',
  CHECK_RESULT_CODE: 'check_result_code',
  PREF_CODE: 'pref_code',
  SURVEY_INDUSTRY_STATUS: 'survey_industry_status',
  SURVEY_REASON_STATUS: 'survey_reason_status',
  ZENSHITETSU_STATUS: 'zenshitetsu_status',
  FISCAL_YEAR_PLAN_SCHEDULE_STATUS: 'fiscal_year_plan_schedule_status',
  PLAN_CLASSIFICATION_CODE: 'plan_classification_code',
  SURVEY_IMPLEMENTATION_STATUS_CODE: 'survey_implementation_status_code',
  VISIT_STATUS_CATEGORY: 'visit_status_category',
  BRANCH_CIRCUIT_MEASURING_SEQ_CODE: 'branch_circuit_measuring_seq_code',
  SOKUTEI_METHOD_CD: 'sokutei_method_cd',
  SURVEY_QUALITY_CATEGORY: 'survey_quality_category',
  CHECK_RESULT_LIST_CODE: 'check_result_list_code',
  CONTRACT_TYPE_CODE: 'contract_type_code',
  SURVEY_BAD_CONTENT: 'survey_bad_content',
  TAKE_OUT_STATUS_CODE: 'take_out_status_code',
  REPORT_STATUS_CODE: 'report_status_code',
  SURVEY_CHECK_PATH_LENGTH_STATUS: 'survey_check_path_length_status',
  SURVEY_CHECK_TARGET_MANAGEMENT_ADD_STATUS: 'survey_check_target_management_add_status',
  CUSTOMER_INDIVIDUAL_MANAGEMENT_STATUS: 'customer_individual_management_status',
  ISUNNECESSARY: 'isunnecessary',
  KG_KSG_TTK_BSH_KBN: 'kg_ksg_ttk_bsh_kbn',
  SURVEY_CATEGORY_CODE: 'survey_category_code',
  CHECK_BAD_LIST_CODE: 'check_bad_list_code',
  NEGATION_LIST_CODE: 'negation_list_code',
  LEDGER_OUTPUT_CATEGORY: 'ledger_output_category',
  APPROVAL_RECORD_TYPE: 'approval_record_type',
  GOAL_INVEST_SETTING_STATUS: 'goal_invest_setting_status',
  USER_TYPE_CODE: 'user_type_code',

};

/** 入力票種別コード. */
export const INPUT_TYPE= {

  SURVEY_YEAR: '01', // 調査年度・委託エリア
  SURVEY_INDUSTRY: '02', // 調査業種
  SURVEY_REASON: '03', // 調査理由
  ZENSITETU: '04', // 全使撤
};
// TODO 削除予定 start
// 一束化区分
export const ISSOKUKA_TYPE = {
  TANDOKU: '1', // 単独
  NISYA: '2', // 2者
  SANSYA: '3', // 3者
  YONSYA: '4', // 4者
};

// 申込区分
export const ORDER_CATEGORY = {
  ORDER: '1', // 共架申込
  KAISYU_IRAI_JYUNSI: '2', // 改修依頼(巡視)
  KAISYU_IRAI_HUTEKI: '3', // 改修依頼(不適)
  KYOGATYU_TOROKU: '4', // 共架柱登録
  TASYATYU_ORDER: '5', // 他社柱申込
  TORIKESI_ORDER: '6', // 申込取消
  ISSOKUKA_AITESAKI: '7', // 一束化相手先
  SYOYUKEN_ITEN: '8', // 所有権移転
};

// 契約申込種別
export const ORDER_KIND = {
  IPPAN: 0, // 一般共架
  GAIROTO: 1, // 街路灯
};

// 共架設備種別
export const KYOGA_SETUBI_TYPE = {
  TUSHIN: '1', // 通信設備
  KIKI: '2', // 機器設備
  GAIRO: '3', // 街路灯
};

// 既設区分
export const KISETU_CATEGORY = {
  ORDER: '1', // 申込
  KISETU_HOSEI: '2', // 既設補正
};

// 径間種別
export const KEIKAN_TYPE = {
  ORDER: '0', // 申込
  KYODO: '1', // 強度計算
};

// 申込ステータス
export const ORDER_STATUS = {
  ORDER_CREATED: '01', // 作成中
  GIJYUTU_KENTO_SHINSEITYU: '02', // 技術検討申請中
  ORDER_RECEIVE: '03', // 技術検討承認済み/申込済
  ORDER_CANCELING: '04', // 取消申請中
  ORDER_RECEIVED: '07', // 申込受付済
  GIJYUTU_KENTO_IRAIZUMI: '11', // 技術検討依頼済
  GIJYUTU_KENTO_KIJYO_MISYONIN: '13', // 技術検討中／机上結果未承認
  GIJYUTU_KENTO_IRAIMI_GENBA: '14', // 技術検討中/現場依頼未
  GIJYUTU_KENTO_IRAIZUMI_GENBA: '15', // 技術検討中/現場依頼済
  GIJYUTU_KENTO_GENBA_MISYONIN: '16', // 技術検討中/現場結果未承認
  ORDER_SYUSEI_TOROKESI: '17', // 申込修正／取消要
  GIJYUTU_KENTOZUMI_KAISYU_SEKKEITYU: '21', // 技術検討済/改修設計中
  KAISYU_SEKKEIZUMI_KANRYOBIMI: '22', // 改修設計済完了日未
  KAISYU_SEKKEI_MISYONIN: '23', // 改修設計未承認
  KAISYU_SEKKEI_ZUMI: '24', // 改修設計済
  KYOGA_ORDER_MI: '26', // 共架申込未
  KYOGA_ORDER_SHINSEITYU: '27', // 共架申込申請中
  KYOGA_ORDER_CYU: '28', // 共架申込中
  KOJI_ORDER_SUMI: '31', // 工事依頼済
  KOJI_PLAN_ZUMI: '32', // 工事計画済
  KOJI_COMPLETE: '33', // 工事完了
  KYOGAKOJI_KAISHI_KA: '41', // 共架工事開始可
  SYUNKO_TOROKU_SHINSEITYU: '43', // しゅん工登録申請中
  SYUNKO_TOROKU_SUMI: '44', // しゅん工登録済
  SISETU_KAKUNINCHU: '45', // 施設確認中
  SISETU_KAKUNINKEKKA_MISHONIN: '46', // 施設確認結果未承認
  KANKETSU_TORIKESHI: '53', // 完結(取消)
  TOROKU_ZUMI_ITEN_MI: '54', // 登録済（移転処理未）
  JYUNSI_KAISYU_TUTI_CREATE: '61', // 巡視改修通知作成中
  KAISYU_TUTI_HAKKO_SHINSEITYU: '62', // 改修通知発行申請中
  KAISYU_TUTI_SUMI: '63', // 改修通知済
  KAISYU_HOUHOU_KENTOTYU: '64', // 改修方法検討中
  KYOGIKEKKA_TOROKUZUMI: '65', // 協議結果登録済(当社起因)
  KYOGASYA_KAISYU_KOJI_TYU: '66', // 共架者改修工事中
  KAISYU_KOJI_MOUSIKOMI_MI: '68', // 改修工事申込未
  KAISYU_KOJI_MOUSIKOMI_SINSEI_CHU: '69', // 改修工事申込申請中
  KAISYU_KAHI_HANTEI_IRAIMI: '72', // 改修可否判定依頼未
  KAISYU_KAHI_HANTEI_IRAITYU: '73', // 改修可否判定依頼中
  TOUSYA_KAISYU_SASIMODOSI: '74', // 当社改修否差戻
};

// 共架柱登録ステータス
export const KYOGATYU_TOROKU_STATUS = {
  CREATE: '0', // 作成中
  TOROKU_SHINSEITYU: '1', // 共架柱登録申請中
  MIKAKUNIN: '2', // 共架者未確認
  KAKUNIN_SHINSEITYU: '3', // 共架者確認申請中
  KANKETSU: '4', // 完結
};


// 電柱所有者
export const OWNER = {
  CHUDEN_HAIDEN: '1', // 中電（配電）
  CHUDEN_TUSHIN: '2', // 中電（通信）
};

// 有無区分
export const UMU_CATEGORY = {
  ARI: '1',
  NASHI: '0',
};

// 異動種別
export const IDO_TYPE = {
  SHINSETU: '1',
  HAISHI: '2',
  HENKO: '3',
};

// 電柱ID種別
export const DNT_ID_TYPE = {
  BUKKEN_SETUBI: '1',
  BUKKEN_BUNKI: '2',
  SETUBI: '3',
  BUNKI: '4',
  MITOUROKU: '5',
};

// 取付手段
export const TORITUKE_WAY = {
  JIKADUKE: 'D', // 直付
  DENTU_TURISEN: 'T', // 電通吊線
};

// 架設設備コード
export const KASETU_SETUBI_CD = {
  OTHER_SETUBI: '699', // その他：その他設備
};

// 最接近配電設備
export const SAISEKKIN_HAIDEN_SETUBI = {
  KOATU_ZETUEN: '1', // 高圧線：絶縁電線
  KOATU_CABLE: '2', // 高圧線：ケーブル
  TEIATU_ZETUEN: '3', // 低圧線：絶縁電線
  TEIATU_CABLE_KOATU: '4', // 低圧線：ケ－ブル・高圧絶縁電線
  TEIATU_CABLE_KOATU2: '5', // 低圧線：ケ－ブル・高圧絶縁電線
  TEIATUHIKIKOMI_ZETUEN: '6', // 低圧引込線：絶縁電線
  TEIATUHIKIKOMI_CABLE_KOATU: '7', // 低圧引込線：ケ－ブル・高圧絶縁電線
  TEIATUHIKIKOMI_TOKUBETU: '8', // 低圧引込線：特別高圧絶縁電線
  HENATU: '9', // 変圧器底部
  NTT_KOATU_ZETUEN: '12', // 高圧線：絶縁電線
  NTT_TEIATU_KOATU: '13', // 高圧線：高圧絶縁電線
  NTT_KOATU_CABLE: '14', // 高圧線：ケーブル
  NTT_TEIATU_ZETUEN: '16', // 低圧線：絶縁電線
  NTT_TEIATU_CABLE_KOATU: '17', // 低圧線：高圧絶縁電線
  NTT_HENATU: '18', // 変圧器一次リード線
  NTT_HIKIKOMI: '19', // 引込線
  OTHER: '98', // その他設備
  NASHI: '99', // 該当なし
};

// 線下状況
export const SENKA_JYOKYO = {
  DOROODAN: '1', // 道路横断
  DOROJYO: '2', // 道路上
  HODOJYO: '3', // 歩道上
  ROMENJYO: '4', // 横断歩道橋の路面上
  TETUDO: '5', // 鉄道・軌道横断
  KASEN: '6', // 河川横断・水面上
  OTHER: '7', // その他
};

// 会社区分
export const COMPANY_CATEGORY = {
  IPPAN: '0',
  KYOTEI: '1',
  NTT: '2',
  TUSHIN: '3',
  KYU_IPPAN: '4',
};

// 会社種別
export const COMPANY_TYPE = {
  NTT: 'NTT',
  OTHER: 'NTT以外',
  ALL: '両方',
};

export const KYOGATYU_HENKO_STATUS = {
  HENKO_CREATED: '01', // 作成中)(事前)
  HENSHUZUMI_ZIZEN: '02', // 編集済（事前）
  HENSHUZUMI_HON: '03', // 編集済（本）
  HENKORENRAKUTYU_ZIZEN: '11', // 変更連絡中（事前）
  HENKORENRAKUZUMI_ZIZEN: '21', // 変更連絡済（事前）
  HENKORENRAKUTYU_HON: '12', // 変更連絡中（本）
  HENKORENRAKUTYU_TORIKESHI: '14', // 変更連絡中（取消）
  HENKORENRAKUZUMI_HON: '22', // 変更連絡済（本）
  HENSHUCHU_TORIKESHI: '33', // 編集中（取消）
  YOTEI_TOUROKU: '41', // 予定登録中
  YOTEI_TOUROKUZUMI: '42', // 予定登録済
  ISETUTYU: '43', // 移設中
  KYOGAKOUJI_ZUMI_KARIYU: '44', // 共架者工事完了済(仮有）
  KYOGAKOUJI_ZUMI: '45', // 共架者工事完了済
  KANKETU_ISETU: '51', // 完結（移設済）
  KANKETU_TORIKESHI: '52', // 完結(取消)
};

export const KYOGATYU_HENKO_KYOGASYA_STATUS = {
  MITUTI: '01', // 未通知
  MIJYURI_JIZEN: '02', // 未受理（事前）
  MIJYURI_HON: '03', // 未受理（本）
  JYURIZUMI_JIZEN: '11', // 受理済（事前）
  JYURIZUMI_HON: '12', // 受理済（本）
  YOTEI_TOUROKUZUMI: '21', // 予定登録済
  KARI_ZUMI: '22', // 仮移設済
  KANKETU_ISETU: '31', // 完結（移設済）
  KANKETU_TORIKESHI: '32', // 完結（取消）

};

export const MOSIKOMISYA_YUSYOMUSYO_CATEGORY ={
  YUSHOU: '0', // 有償
  MUSHOU: '1', // 無償
};

export const HENKOU_RENRAKU_CATEGORY ={
  JIZEN: '0', // 事前
  HON: '1', // 本
  TORIKESHI: '3', // 取消
};

export const KAHI_CATEGORY ={
  KA: '0', // 可
  HI: '1', // 否
};

// 要否区分
export const YOUHI_CATEGORY = {
  YOU: '1',
  HI: '0',
};

// 技術検討結果
export const GIJYUTU_KENTO_KEKKA_CATEGORY = {
  KYOGA_KANOU: '1', // 共架可（条件無し）
  KYOGA_KANOU_JOKEN_ARI_SYUSEI_YOU: '2', // 共架可（条件有り,申込修正要）
  KYOGA_KANOU_JOKEN_ARI_SYUSEI_NASI: '3', // 共架可（条件有り、申込修正不要）
  KYOGA_HUKA: '4', // 共架不可
  GENBA_TYOSA_YOU: '5', // 現場調査要
};

// 技術検討結果 可条件
export const GIJYUTU_KENTO_KEKKA_KAJOKEN_CATEGORY = {
  ISSOKUKA_YOUTYOUSEI: '01', // 一束化相手と調整要
  TASYASETUBI_KAISYUIRAIYOU: '02', // 他社設備改修依頼要
  KYODOSISEN_ENTYOYOU: '03', // 共同支線の施設（延長）要
  SONOTA_SYUSEIYOU: '09', // その他（申込修正要）
  TYUDEN_KAIAYUKOJIYOU: '11', // 中電改修工事要
  HIIPARIKAJYU_SIJIARI: '12', // 引張荷重指示有り
  ISSOKUKA_GOUIZUMI: '13', // 一束化（合意済）
  TASYASETUBI_KAISYU_GOUIZUMI: '14', // 他社設備改修（合意済）
  SONOTA_SYUSEIHUYOU: '19', // その他（申込修正不要)
};

// 技術検討 共架不可理由
export const GIJYUTU_KENTO_KEKKA_FUKARIYU = {
  GUIDE_LINE1: '1', // 総務省ガイドライン第3条第1号に該当
  GUIDE_LINE2: '2', // 総務省ガイドライン第3条第2号に該当
  GUIDE_LINE3: '3', // 総務省ガイドライン第3条第3号に該当
  GUIDE_LINE4: '4', // 総務省ガイドライン第3条第4号に該当
  GUIDE_LINE5: '5', // 総務省ガイドライン第3条第5号に該当
  GUIDE_LINE6: '6', // 総務省ガイドライン第3条第6号に該当
  GUIDE_LINE7: '7', // 総務省ガイドライン第3条第7号に該当
  GUIDE_LINE8: '8', // 総務省ガイドライン第3条第8号に該当
  GUIDE_LINE9: '9', // 総務省ガイドライン第3条第9号に該当
  SONOTA: '99', // その他
};

// 技術検討 現場調査回付理由
export const GIJYUTU_KENTO_KEKKA_GENBARIYU = {
  SIJIBUTU_MUKI: '1', // 支持物の向きが不明
  SIJIBUTU_SYAKU_KYODO: '2', // 支持物の丈尺・強度が不明
  KEIKAN_KAKUNIN: '3', // 径間・角度・弛度・地上高要確認
  SONOTA: '9', // その他
};

// 紐移設実施区分
export const HIMO_IAETU_JISSI_CATEGORY = {
  KYOGASYA: '1', // 共架者
  HAIDEN: '2', // 配電
  TUSIN: '3', // 通信
};

// 要否区分（配電改修設計）
export const YOUHI_CATEGORY_HAIDEN_KAISYU = {
  YOU_HIMOISETU_NOMI: '1',
  YOU_HIMOISETU_NOZOKU: '2',
  HI: '0',
};

// 伝票区分
export const DEMPYO_CATEGORY = {
  KANREN: '0',
  HAIDEN_SINKI: '1',
  TUSIN_SINKI: '2',
  KISETU: '3',
};

// 承認ステータス
export const APPROVAL_STATUS = {
  SAKUSEI_TYU: '10', // 作成中
  SYONIN_TYU: '60', // 承認中
  KANRYO: '90',  // 完了
  TORIDOME: '00',  // 取止済
};

// ユーザ種別コード
export const USER_TYPE_CODE = {
  SYSTEM_KANRI: '00', // システム管理者
  HONSYASYSTEM_KANRI: '10', // 本社システム管理
  HONSYAGYOMU_KANRI: '11',  // 本社業務管理
  NWC_KANRI: '12',  // NWC管理職
  NWC_TANTOU: '13',  // NWC担当者
  HONTEN: '21',  // 本店
  KANRI: '22',  // 管理職
  SIBU_KANRI: '31',  // 支部管理職
  SIBU_TANTOU: '32',  // 支部担当者
  TYOUSAIN: '33',  // 調査員
};

// 共架柱変更_対象柱工事内容
export const KYOGATYU_HENKO_KOJI_NAIYO = {
  TATEKAE: '1', // 建替
  MOTO: '2', // 元位置建替
  SINSETU: '3', // 新設
  TEKKYO: '4', // 撤去
  OTHER: '9', // その他
};

// 共架柱変更移設工事内容
export const KYOGATYU_HENKO_ISETU_KOJI_NAIYO = {
  TUKEKAE: '01', // 電柱建替に伴い共架設備付け替え
  SETUBI_DOWN: '02', // 共架設備繰り下げ
  SETUBI_UP: '03', // 共架設備繰り上げ
  OTHER: '09', // その他
  MOSIKOMI_TEKYO: '11', // 不要線のため撤去（共架申込要）
  MOSIKOMI_NASI: '12', // 現地設備無し（共架申込要）
  MOSIKOMI_TORIHAZU: '13', // 電柱間引に伴い取り外し（共架申込要）
  MOSIKOMI_TORITUKE: '14', // 電柱割込新設に伴い取り付け（共架申込要）
  MOSIKOMI_OTHE: '19', // その他（共架申込要）
};

// 共架費用区分
export const KYOGA_HIYO_CATEGORY = {
  KYOGA_HOKA: '000', // 共架料ほか
  KYOGA: '010', // 共架料
  TEKI_KYOGA: '011', // 定期共架料
  TUKIWARI_KYOGA_SINSETU: '012', // 月割共架料（新設）
  TUKIWARI_KYOGA_TEKKYO: '013', // 月割共架料（撤去）
  TUKIWARI_KYOGA: '015', // 月割共架料
  KYOGA_SEIKYU: '016', // 共架料（請求）
  KYOGA_SIHARAI: '017', // 共架料（支払）
  SEISAN_KYOGA: '020', // 精算共架料
  GIJYUTU_KENTO_HIYO: '030', // 技術検討費用
  KAISYU_KOJI_HIYO_YOTE: '040', // 改修工事費用（予定）
  KAISYU_KOJI_HIYO_KANKO: '041', // 改修工事費用（完工）
  KARIISETU_HIYO: '050', // 仮移設費用
  SYUNKO_DAIKO_HIYO: '060', // しゅん工報告代行費用
  KYOGA_ORDER_DAIKO_HIYO: '061', // 共架申込代行費用
  SYUNKO_TYOSA_HIYO: '070', // しゅん工調査費用
  ENTAI: '080', // 延滞利息
  KOBETU_SEIKYU_HIYO_SINSEI: '090', // 個別費用請求・払戻
};
export const HENKO_RENRAKU_TAISYO = {
  TAISYO: '1', // 対象
  TAISYOGAI: '2', // 対象外
};

export const HENKO_RENRAKU_TUTI_HOHO = {
  SYSTEM: '1',      // システム
  KOBETU_TAIO: '2', // 個別（事業場対応）
  KOBETU_HASO: '3', // 個別（集中部署発送）
};

// 施設確認結果
export const TEKI_FUTEKI_CATEGORY ={
  TEKI: '0', // 適
  HUTEKI: '1', // 不適
};

// 不適区分
export const FUTEKI_CATEGORY={
  RIKAKU_FUSOKU: '1', // 離隔不足
  TIJYO_HEIGHT_FUSOKU: '2', // 地上高不足
  KISAI_MORE: '3', // 記載漏れ
  TENPU_MORE: '4', // 添付漏れ
  PIC_SOI: '5', // 写真相違
  PIC_FUSENMEI: '6', // 写真不鮮明
  DNTNO_SOI: '7', // 電柱番号相違
  OTHER: '9', // その他
};

// 改修設計（配電）ステータス
export const KAISYU_SEKKEI_HAIDEN_STATUS = {
  KAISYU_SEKKEI_MI: '1',        // 改修設計未
  KAISYU_SEKKEI_ZUMI: '2',      // 改修設計済
};

// 改修設計（通信）ステータス
export const KAISYU_SEKKEI_TUSIN_STATUS = {
  KAISYU_SEKKEI_MI: '1',        // 改修設計未
  KAISYU_SEKKEI_SYONIN_MI: '2', // 改修設計承認未
  KAISYU_SEKKEI_ZUMI: '3',      // 改修設計済
};

export const COMPANY_CD = {
  CHUDEN_PG: '1', // 中電PG
  CHS: '2', // CHS
};

export const ZIGYOJO_CATEGORY = {
  HAIDEN: '1', // 配電
  TUSIN: '2', // 通信
  HAIDEN_ITAKU: '11', // 配電委託
  TUSIN_HOSYU: '21', // 通信保守
};

export const ZIGYOJO_LEVEL = {
  SISAYA: '10', // 配電
  EREA_SISYA: '20', // 通信
  TUSIN_CENTER: '25', // 配電委託
  ICHIGATA_SS: '30', // 通信保守
  NIGATA_SS: '40', // 通信保守
};

// 役割ロールID（アクター種類）
export const ROLE_ID = {
  KYOGASYA: '00',
  HAIDENBU: '01',
  KYOGA: '02',
  SEKKEI: '03',
  KOJI: '04',
  KENSA: '05',
  YOUTI: '06',
  SETUBI_HOSYU: '07',
  UKETUKE_TEAM: '08',
  GIJYUTU_TEAM_CENTER: '09',
  GIJYUTU_TEAM_KYOTEN: '10',
  GIJYUTU_TEAM_GENBA: '11',
  TUSIN_CENTER: '12',
  TUSIN_HOSYUKAISYA: '13',
  SYSTEM_UNYOHOSYU: '14',
};

/** 共架申込取込ファイル 申込ヘッダ */
export const KYOGA_ORDER_HEADER = {
  '共架者申込番号': 'kyogasyaOrderNo',
  '工事件名': 'kojiKenmei',
  '事業場': 'kojibasyoZigyojo',
  '代表電柱番号': 'kojibasyoDaihyoDntNo',
  '都道府県': 'kojibasyoPrefectures',
  '市区郡町村': 'kojibasyoMunicipalities',
  '大字通称': 'kojibasyoOazatusyo',
  '字丁目': 'kojibasyoAzatyome',
  'ビル名等': 'kojibasyoBirumei',
  'メモ内容': 'memoRan',
  '改修工事無条件実施\r\n（希望する、希望しない）': 'kaisyuKojiJissiCategory',
  '着工予定日': 'tyakkoYoteiDate',
  'しゅん工予定日': 'syunkoYoteiDate',
};

/** 共架申込取込ファイル 設備電柱ヘッダ */
export const KYOGA_ORDER_SETUBI_HEADER = {
  '取込区分': 'torikomiKbn',
  '事業場': 'zigyojoCd',
  '電柱番号': 'dntNo',
  '枝番': 'edaban',
  '施設名': 'dntCategory',
  '物件番号_共架物件マスタ': 'bukkenNoBukkenMaster',
  '異動種別': 'idoType',
  '架設設備種別': 'kasetuSetubiType',
  '架設設備': 'kasetuSetubiCd',
  '架設分類': 'kasetuBunrui',
  '共架設備番号': 'kyogaSetubiNo',
  '取付手段': 'toritukeWay',
  '取付方位': 'toritukeHoi',
  '取付種別': 'toritukeType',
  '占有サイズ': 'senyuSize',
  '線下状況': 'senkaJyokyo',
  '通信センター協議完了': 'kyogiKanryoFlag',
  '一束化区分': 'issokukaCategory',
  '備考': 'biko',
  '地上高（m）': 'tijyoHeight',
  '最接近配電設備': 'saisekkinHaidenSetubi',
  '配電設備との離隔（m）': 'haidenSetubiRikaku',
  '通信線との離隔_上位（m）': 'tusinsenRikakuJyoi',
  '通信線との離隔_下位（m）': 'tusinsenRikakuKai',
  '使用有無': 'yaridasiSiyoUmu',
  '使用理由': 'yaridasiSiyoRiyu',
  '開閉器操作紐移設要否': 'sousaHimoIsetuYohi',
  '改修内容': 'kaisyuKojiIraiNaiyo',
  '移動(m)': 'kaisyuKojiIraiIdo',
  '記事欄': 'kaisyuKojiIraiKiji',
};

/** 共架申込取込ファイル 設備径間ヘッダ */
export const KYOGA_ORDER_KEIKAN_HEADER = {
  '取込区分(1)': 'torikomiKbn1',
  '事業場(1)': 'zigyojo1Cd',
  '電柱番号(1)': 'dntNo1',
  '枝番(1)': 'edaban1',
  '施設名(1)': 'dntCategory1',
  '取込区分(2)': 'torikomiKbn2',
  '事業場(2)': 'zigyojo2Cd',
  '電柱番号(2)': 'dntNo2',
  '枝番(2)': 'edaban2',
  '施設名(2)': 'dntCategory2',
  '異動種別': 'idoType',
  '架設設備': 'kasetuSetubiCd',
  '径間(m)': 'keikanM',
  '線下状況': 'senkaJyokyo',
  '通信元との角度（度）': 'motoKakudo',
  '外径(mm)': 'gaikei',
  '自重(kg/m)': 'jijyu',
  '弛度(m)': 'tido',
  '高圧線：絶縁電線（m）': 'keikanRikakuKouatuZetuen',
  '高圧線：ケーブル（m）': 'keikanRikakuKouatuCable',
  '低圧線：絶縁電線（m）': 'keikanRikakuTeiatuZetuen',
  '低圧線：ケーブル・高圧絶縁電線（m）': 'keikanRikakuLCableHZetuen',
  '電力引込線（m）': 'keikanRikakuHikikomi',
  '通信線（m）': 'keikanRikakuTusin',
  '備考': 'biko',
};

// 重要度
export const JYUYODO = {
  TUTI: '0', // 通知
  YOUKAKUNIN: '1', // 要確認
  YOUKAITOU: '2', // 要回答
};

// メッセージステータス
export const MESSAGE_STATUS = {
  CREATED: '1', // 作成中
  SOUSIN_ZUMI: '2', // 送信済
  TAIOUTYU: '3', // 対応中
  KAITOU_ZUMI: '4', // 回答済
  KAKUNIN_ZUMI: '5', // 確認済
};

// ユーザーレベル
export const USER_LEVEL = {
  ADMIN: '0', // 管理者
  GENERAL: '1', // 一般
};

// 改修工事（配電）ステータス
export const KAISYU_KOJI_HAIDEN_STATUS = {
  KOJI_IRAIZUMI: '0',        // 工事依頼済
  KOJI_KEIKAKUMI: '1', // 工事計画未
  KOJI_KEIKAKUZUMI: '2',      // 工事計画済
  KOJIKANRYOU: '3', // 工事完了
};

// 改修工事（通信）ステータス
export const KAISYU_KOJI_TUSIN_STATUS = {
  KOJI_IRAIZUMI: '0',        // 工事依頼済
  KOJI_KEIKAKUMI: '1', // 工事計画未
  KOJI_KEIKAKUZUMI: '2',      // 工事計画済
  KOJIKANRYOU: '3', // 工事完了
};

// 共架基本契約ステータス
export const KEIYAKU_STATUS = {
  MOUSIKOMITYU: '1',        // 申込中
  KARI_MOUSIKOMI: '2', // 仮申込
  KEIYAKUSYO_KAKUNINZUMI: '3',      // 契約書案確認済
  HONTEIKETU_MATI: '4', // 契約本締結待ち
  SOUHUZUMI: '5', // 契約送付済
  KANKETU_TEIKETUZUMI: '6', // 完結（締結済）
  KANKETU_HI: '7', // 完結（否）
};
// 同調施工可否
export const DOTYOSEKO_KAHI = {
  KA: '0',     // 可
  HI: '1',      // 否
  FUMEI: '9',   // 不明
};
// 架設設備種別 架設設備コードの値_数値1
export const KASETU_SETUBI_TYPE = {
  TUSHIN: 1,
  KIKI: 2,
  GAIROTO: 3,
};
// TODO 削除予定 end

// 調査管理区分コード
export const SURVEY_MANAGEMENT_CATEGORY_CODE = {
  NON_PRIVATE: '0',      // 非自家用
  LOWPOWER_PRIVATE: '3', // 低圧自家用
  JR_CHECK: 'A',         // ＪＲ調査
  JR_CHECK_REJECT: 'B',  // ＪＲ調査拒否
};

// 調査理由コード
export const SURVEY_REASON_CODE = {
  NMINEXCEED: '12',      // 漏えい電流が1mA超過で未調査
  UNABLEMEASURE: '13', // 漏えい電流の測定不能
  CANCEL: '99',         // 調査理由の取消
};

// 調査業種ステータス
export const SURVEY_INDUSTRY_STATUS = {
  CREATING: '10',   // 作成中
  REPORTING: '40',  // 報告中
  CONFIRMING: '50', // 確認中
  APPROVING: '60',  // 承認中
  COMPLETED: '90',  // 完了
  CANCEL: '00',     // 取止済
};

// 調査年度・委託エリアステータス
export const SURVEY_YEAR_CONSIGNAREA_STATUS = {
  CREATING: '10',   // 作成中
  APPROVING: '60',  // 承認中
  COMPLETED: '90',  // 完了
  CANCEL: '00',     // 取止済
};

// 調査理由ステータス
export const SURVEY_REASON_STATUS = {
  CREATING: '10',   // 作成中
  REPORTING: '40',  // 報告中
  CONFIRMING: '50', // 確認中
  APPROVING: '60',  // 承認中
  COMPLETED: '90',  // 完了
  CANCEL: '00',     // 取止済
};

// 承認ステータス
export const STEP_APPROVAL_STATUS = {
  SHINSEI_MI: '00', // 未申請・承認済
  SHINSEI_TYU: '01', // 申請中
  SHOUNIN_SAI: '02', // 要再承認
  SHINSEI_SAI: '03',  // 要再申請
};

// 会社コード
export const CORP_CD = {
  CBID_USER: '0000', // 中電ＮＷ
  HOAN_USER: '3000', // 保安協会
  KOGYO_USER: '5000', // 工業組合
};

// 操作権限区分
export const OPERATION_PERMISSION_TYPE = {
  READONLY: '1', // 参照
  EXECUTE_CSV: '2', // 実行：CSV出力
  EXECUTE_OTHER: '3', // 実行：その他
  EXECUTE: '4', // 実行
};

export const NW_OFFICE_CODE = {
  CHUDEN_NW: '7003', // 中電ＮＷ（配電）
};

// ステップ承認ステータス
export const STEP_APPROVAL = {
  WAIT_APPROVAL: '0', // 承認待ち
  NEXT_APPROVAL: '7', // 次回
  APPROVAL: '1',      // 承認済
  REMAND: '8',        // 差戻
};


// ステップ承認ステータス
export const APPROVAL_RECORD_TYPE = {
  IY: 'IY', // 調査年度・委託エリア
  IB: 'IB', // 調査業種
  IR: 'IR', // 調査理由
  FW: 'FW', // 全使撤
  SA: 'SA', // 調査点検箇所追加交付
  IM: 'IM', // お客さま個別管理
  YP: 'YP', // 年度計画
  IS: 'IS', // 委託エリア設定
  TS: 'TS', // 調査
  TK: 'TK', // 点検
};
